import React from 'react';
import { bool, func } from 'prop-types';

const Footer = ({
    isTablet,
    isMobile,
    withMetadataCard,
    showPreviews,
    metadataCardRender,
    previewCardRender
}) => (isTablet && (
    <div className="logo-project-card-footer tablet-footer">
        {metadataCardRender()}
        {previewCardRender()}
    </div>
) || isMobile && (
    <div className="logo-project-card-footer">
        {metadataCardRender()}
    </div>
) || withMetadataCard && (
    <div className="logo-project-card-footer">
        {!showPreviews && metadataCardRender()}
        {showPreviews && previewCardRender()}
    </div>
));

Footer.propTypes = {
    isTablet: bool,
    isMobile: bool,
    withMetadataCard: bool,
    showPreviews: bool,
    metadataCardRender: func,
    previewCardRender: func
};

export default Footer;
